export function isDomainAllowed(hostname: string, allowedDomains: string[]): boolean {
  // Always allow localhost for development (regardless of allowedDomains)
  if (hostname === 'localhost' || hostname === '127.0.0.1') return true;

  if (!allowedDomains || allowedDomains.length === 0) return false;

  for (const raw of allowedDomains) {
    // Normaliza: remove protocolo (https:// ou http://) e trailing slash
    const pattern = raw.replace(/^https?:\/\//, '').replace(/\/$/, '');
    if (pattern === hostname) return true;
    if (pattern.startsWith('*.')) {
      const suffix = pattern.slice(1); // '.domain.com'
      if (hostname.endsWith(suffix)) return true;
    }
  }
  return false;
}
